module.exports = __webpack_public_path__ + "static/media/team-10.b6cf8bca.png";